<template>
  <div v-if="dirtyLogs" :class="$style.container">
    <div
      v-for="(activityItem, activityItemIndex) in dirtyLogs"
      :key="activityItemIndex"
      class="data-collection-activitylogs-row-container"
      :class="$style.item"
    >
      <b-collapse
        aria-id="contentIdForA11y2"
        class="panel"
        animation="slide"
        v-model="isRecordOpen"
        :open="isRecordOpen"
      >
        <div
          slot="trigger"
          slot-scope="props"
          class="panel-heading data-collection-activitylog-panel-heading"
          role="button"
          aria-controls="contentIdForA11y2"
        >
          <div class="columns">
            <div class="column is-1 time-period">
              {{ getDateTime(activityItem.recordedStartDateTime) }}
            </div>
            <div class="column title-content">
              <span
                v-for="(word, wordIndex) in getTitle(activityItem)"
                :key="wordIndex"
              >
                <span v-if="wordIndex === 0" class="bold">{{ word }}</span>
                <span v-else> {{ word }}</span>
              </span>
            </div>
            <div class="columns column is-2">
              <div class="column edit-btn">
                <router-link
                  :class="$style.editBtn"
                  :to="
                    '/audits/' +
                    auditDetail.id +
                    '/data-collections/' +
                    activityItem.id
                  "
                >
                  <b-icon icon="pencil" size="is-small" />
                </router-link>
              </div>
              <div class="column delete-btn">
                <a
                  :class="$style.deletebtn"
                  @click="deleteDataCollectionRecord(activityItem)"
                >
                  <b-icon icon="delete" size="is-small" />
                </a>
              </div>
              <div
                :class="[
                  !isDataCollectionActive ? $style.centerAccordian : null,
                  'column',
                  'accordion-btn',
                ]"
              >
                <a :class="$style.accordionbtn">
                  <b-icon :icon="props.open ? 'menu-up' : 'menu-down'" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-block" :class="$style.panelBlockContainer">
          <div class="data-recorded-row">
            {{ getDataRecordedRowinfo(activityItem) }}
          </div>
          <div
            v-if="
              activityItem.dataCollectionType === 'individual' &&
              activityItem.aid
            "
            class="data-recorded-aid"
          >
            Sample Code : {{ activityItem.aid }}
          </div>
          <div
            v-if="
              activityItem.comments !== '' && activityItem.comments !== null
            "
          >
            <div class="data-comment-row">Overall Comment</div>
            <div class="data-comment-data-row">{{ activityItem.comments }}</div>
          </div>
          <div
            v-for="(
              dataCollectionRecords, index
            ) in activityItem.dataCollectionRecords"
            class="data-per-criteria-row"
            :key="index"
            :class="
              index === 0 ? $style.applyPaddingTopFirstChildCriteriaRow : null
            "
          >
            <div class="columns data-info-row">
              <div class="column index-column">{{ index + 1 }}.</div>
              <CriteriaViewUpdateComponent
                :criteria="dataCollectionRecords.auditCriteria.criteria"
              />
            </div>
            <div class="columns data-table-row">
              <div class="column empty-column-data-table"></div>
              <div class="column table-column">
                <div class="row-table-heading">
                  <div class="col-answer-choices">Answer Choices</div>
                  <div class="col-responses">Count</div>
                </div>
                <div
                  :class="[
                    getOptionValues(
                      dataCollectionRecords,
                      activityItem.dataCollectionType,
                    ).length > 8
                      ? $style.scrollableColumn
                      : $style.nonScrollableColumn,
                  ]"
                >
                  <div
                    :class="
                      activityItem.dataCollectionType !== 'individual' ||
                      dataCollectionRecords.auditCriteria.criteria
                        .criteriaType !== 'BOOLEAN'
                        ? 'row-table-options'
                        : 'row-table-options-unique'
                    "
                    v-for="(optionValue, index) in getOptionValues(
                      dataCollectionRecords,
                      activityItem.dataCollectionType,
                    )"
                    :key="index"
                  >
                    <div class="option-element">
                      {{ optionValue.option }}
                    </div>
                    <div class="option-element-count">
                      {{
                        (optionValue.value !== 0 ? '+' : '') +
                        (optionValue.value ? optionValue.value : 0)
                      }}
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    activityItem.dataCollectionType !== 'individual' ||
                    dataCollectionRecords.auditCriteria.criteria
                      .criteriaType !== 'BOOLEAN'
                  "
                  class="row-table-total"
                >
                  <div class="col-total-collected">Total Collected</div>
                  <div class="col-total-collected-count">
                    {{
                      (getInteger(dataCollectionRecords.total) !== 0
                        ? '+'
                        : '') + getInteger(dataCollectionRecords.total)
                    }}
                  </div>
                </div>
                <div
                  v-if="
                    dataCollectionRecords.comments !== '' &&
                    dataCollectionRecords.comments !== null
                  "
                >
                  <div
                    class="criteria-comment-row"
                    :class="
                      activityItem.dataCollectionType !== 'individual' ||
                      dataCollectionRecords.auditCriteria.criteria
                        .criteriaType !== 'BOOLEAN'
                        ? null
                        : $style.removeCommentBoxMargin
                    "
                  >
                    Comment
                  </div>
                  <div class="criteria-comment-data-row">
                    {{ dataCollectionRecords.comments }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
      <hr v-if="activityItemIndex + 1 !== dirtyLogs.length" class="divider" />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CriteriaFilter from '@/views/Audit/components/CriteriaFilter.vue';
import { AuditDetail } from '@/store/modules/audits/types/audits.types';
import { cloneDeep as _cloneDeep, map as _map } from 'lodash';
import BasePagination from '@/components/base/BasePagination.vue';
import { useUserEmail } from '@/utils/user.util';
import moment from 'moment';
import { CRITERION_TYPE } from '../../../store/types/criterions.types';
import CriteriaViewUpdateComponent from '../../Project/components/CriteriaViewUpdateComponent.vue';

const dirtyMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec',
];

@Component({
  components: {
    CriteriaFilter,
    BasePagination,
    CriteriaViewUpdateComponent,
  },
})
export default class DataCollectionActivityLog extends Vue {
  @Prop()
  public dataCollectionActivityLogs!: any[];
  @Prop()
  public auditDetail!: AuditDetail;
  @Prop({ default: true })
  public editable!: boolean;
  @Prop({ default: false })
  public isDataCollectionActive!: boolean;

  public nowDate: Date = new Date();
  public dirtyLogs: any[] = [];
  public isRecordOpen: boolean = false;

  public mounted() {
    this.dirtyLogs = _cloneDeep(this.dataCollectionActivityLogs);
  }

  @Watch('dataCollectionActivityLogs')
  public watchDataCollectionActivityLogs(newValue: any) {
    this.dirtyLogs = _cloneDeep(newValue);
  }

  public getOptionValues(
    dataCollectionRecords: any,
    dataCollectionType: string,
  ) {
    let optionValues = JSON.parse(dataCollectionRecords.optionValues);
    if (
      (dataCollectionRecords.auditCriteria.criteria.criteriaType ===
        CRITERION_TYPE.RANGE ||
        dataCollectionRecords.auditCriteria.criteria.criteriaType ===
          CRITERION_TYPE.CONTINUOUS_DISCRETE) &&
      dataCollectionType === 'individual'
    ) {
      optionValues = optionValues.filter(
        (optionValue: any) => optionValue.value === 1,
      );
    }
    return optionValues;
  }

  public editDataCollectionRecord(rowData: any) {
    this.$emit('editDataCollectionRecord', rowData);
  }

  public deleteDataCollectionRecord(rowData: any) {
    this.$emit('deleteDataCollectionRecord', rowData);
  }

  public formatDate(date: Date) {
    return this.getDate(date);
  }

  public formatTime(date: Date) {
    return this.getTime(date);
  }

  public getPureDate(date: Date | string): number {
    return new Date(date).setHours(0, 0, 0, 0);
  }

  public getDate(newValue: Date) {
    return (
      newValue.getDate() +
      ' ' +
      dirtyMonths[newValue.getMonth()] +
      ' ' +
      newValue.getFullYear()
    );
  }

  public getTime(newValue: Date) {
    return (
      newValue.getHours() +
      ':' +
      ((newValue.getMinutes() < 10 ? '0' : '') + newValue.getMinutes())
    );
  }

  public getInteger(value: string) {
    return parseInt(value, 10) ? Math.round(parseInt(value, 10)) : 0;
  }

  public getDateTime(value: string) {
    const dateDiff = this.nowDate.getTime() - new Date(value).getTime();
    const isYesterday: boolean =
      this.getPureDate(moment(this.nowDate).subtract(1, 'day').toDate()) ===
      this.getPureDate(value);
    const isSameDay =
      this.getPureDate(this.nowDate) === this.getPureDate(value);
    if (isSameDay) {
      const seconds = Math.floor(dateDiff / 1000);
      let interval = seconds / 3600;
      if (interval > 1) {
        return (
          Math.floor(interval) +
          (Math.floor(interval) > 2 ? ' hours ago' : ' hour ago')
        );
      }
      interval = seconds / 60;
      return (
        Math.floor(interval) +
        (Math.floor(interval) > 2 ? ' minutes ago' : ' minute ago')
      );
    }
    return isYesterday ? 'Yesterday' : this.getDate(new Date(value));
  }

  public getTitle(value: any) {
    const currentUserEmail = this.userEmail;
    const titleValue = [];
    const userEmail = value.user.email;
    let dirtyTotal = 0;
    _map(value.dataCollectionRecords, (tempRecord) => {
      dirtyTotal += parseInt(tempRecord.total, 10);
    });
    if (currentUserEmail === userEmail) {
      titleValue.push('You');
    } else {
      titleValue.push(userEmail);
    }
    if (dirtyTotal === 1) {
      titleValue.push('added ' + dirtyTotal + ' response');
    } else {
      titleValue.push('added ' + dirtyTotal + ' responses');
    }
    return titleValue;
  }

  public getDataRecordedRowinfo(value: any) {
    const recordedStartDateTime = new Date(value.recordedStartDateTime);
    const recordedEndDateTime = value.recordedEndDateTime
      ? new Date(value.recordedEndDateTime)
      : new Date(value.recordedStartDateTime);
    const siteName = value.auditSite.site.name;
    switch (this.auditDetail.auditDataTimestamp) {
      case 'Single Date':
        return `Data recorded on ${this.formatDate(
          recordedStartDateTime,
        )} at ${siteName}`;
      case 'Single Date with Time':
        return `Data recorded on ${this.formatDate(recordedStartDateTime)} ;
                            ${this.formatTime(
                              recordedStartDateTime,
                            )} at ${siteName}`;
      case 'Date Range':
        return `Data recorded between ${this.formatDate(
          recordedStartDateTime,
        )} and
                            ${this.formatDate(
                              recordedEndDateTime,
                            )} at ${siteName}`;
      case 'Date Range with Time':
        return `Data recorded between ${this.formatDate(
          recordedStartDateTime,
        )} ;
                            ${this.formatTime(recordedStartDateTime)} and
                            ${this.formatDate(recordedEndDateTime)} ;
                            ${this.formatTime(
                              recordedEndDateTime,
                            )} at ${siteName}`;
      default:
        return `Data recorded at ${siteName}`;
    }
  }

  get userEmail(): string | undefined {
    return useUserEmail.call(this);
  }
}
</script>
<style lang="scss" module>
.container {
  margin-top: 1rem;
  background-color: white;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  overflow: hidden;
}

.editBtn {
  color: #21b5ea;
}
.deletebtn {
  color: #21b5ea;
}
.accordionbtn {
  color: #21b5ea;
}
.panelBlockContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 0px;
  padding-bottom: 0px;
}
.applyPaddingTopFirstChildCriteriaRow {
  padding-top: 24px;
}
.removeCommentBoxMargin {
  margin-top: 0px !important;
}
.centerAccordian {
  margin-right: 30px;
  text-align: right !important;
}
.scrollableColumn {
  overflow-y: scroll;
  height: 220px;
}
.nonScrollableColumn {
  height: auto;
}
</style>
